import React from 'react';
import ReceivedEntryFunctional from './components/received-entry-list-functional';

const ReceivedEntry = () => {
	return <ReceivedEntryFunctional />;
};

export default ReceivedEntry;
